<template>
    <v-layout style="padding:20px;">
        <v-flex xs12>
            <v-toolbar flat dense color="white black--text">
                <v-toolbar-title class="dark-grey--text  subheading">
                    <strong<b>Size Scales List</b></strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" placeholder="Search" class="black--text "
                    color="black"></v-text-field>
                <v-spacer></v-spacer>
                <div class="text-xs-right">
                    <v-icon flat class="icon-color" @click="showDialog = true">add</v-icon>
                    <v-icon flat class="icon-color">print</v-icon>
                    <v-icon flat class="icon-color">mdi-download</v-icon>
                    <v-icon flat class="icon-color">mdi-export</v-icon>
                    <v-icon flat class="icon-color">delete</v-icon>
                </div>
            </v-toolbar>
            <hr>
            <v-data-table :headers="headers" :items="sizeScales" :search="search" select-all v-model="selected"
                :pagination.sync="pagination">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td class="text-xs-left">{{ props.item.id }}</td>
                        <td class="text-xs-left">{{ props.item.companies.name }}</td>
                        <td class="text-xs-left">{{ props.item.code }}</td>
                        <td class="text-xs-left">{{ props.item.ind_size }}</td>
                        <td class="text-xs-left">{{ props.item.sequence_num }}</td>
                        <td>
                            <IconEye @clicked="editItem(props.item.id)" />
                            &nbsp;
                            <IconEdit @clicked="editItem(props.item.id)" />
                            &nbsp;
                            <IconTrash v-if="!props.item.processing" @clicked="changeStatus(props.item.id, props.index)" />

                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-dialog v-model="showDialog" max-width="500px">
            <SizeScaleForm v-if="showDialog" :sizeScaleId="selectedSizeId" v-on:closeDialog="closeDialog" />
        </v-dialog>
        
        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title class="headline">Confirm Delete</v-card-title>
                <v-card-text>Are you sure you want to delete this size scale?</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="deleteDialog = false" :disabled="deleting">Cancel</v-btn>
                    <v-btn color="red" dark @click="confirmDelete" :loading="deleting" :disabled="deleting">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>

import SizeScaleModel from '@/api/service/SizeScaleService';
import IconEdit from '@/components/Icons/IconEdit.vue';
import IconTrash from '@/components/Icons/IconTrash.vue';
import IconEye from '@/components/Icons/IconEye.vue';
import SizeScaleForm from '@/components/SizeScaleForm.vue'

export default {
    props: [

    ],
    components: {
        IconEye,
        IconEdit,
        IconTrash,
        SizeScaleForm
    },
    data() {
        return {
            selectedSizeId: 0,
            search: '',
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 5,
                sortBy: 'id',
                totalItems: 0,
                rowsPerPageItems: [1, 2, 4, 8, 16]
            },
            selected: [],
            headers: [
                { text: 'Id', value: 'id' },
                { text: 'Company Id', value: 'companies.name' },
                { text: 'Code', value: 'code' },
                { text: 'Ind Size', value: 'ind_size' },
                { text: 'Sequence Number', value: 'sequence_num' },
                {}
            ],
            showDialog: false,
            deleteDialog: false,
            deleteId: null,
            deleting: false,
            published: [],
            availbleList: [],
            sizeScales: [
            ]
        }
    },
    created: function () {
        this.getSize()
    },

    mounted: function () {
        
    },
    methods: {
        getSize() {
            let company = localStorage.getItem('tiburaReportsUser')
            let companyId = JSON.parse(company).data.User.company_id
            SizeScaleModel.getSizeScales(companyId)
                .then(response => {
                    this.sizeScales = (response)
                }).catch(error => {
                    console.log(error)
                });
        },
        closeDialog() {
            this.selectedSizeId = 0
            this.showDialog = false
            this.getSize()
        },
        editItem($item) {
            this.selectedSizeId = $item
            this.showDialog = true
        },
        changeStatus(id) {
            this.deleteId = id;
            this.deleteDialog = true;
        },
        confirmDelete() {
            this.deleting = true;
            SizeScaleModel.delete(this.deleteId).then(() => {
                this.getSize();
                this.deleteDialog = false;
                this.deleteId = null;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.deleting = false;
            });
        }
    }
}
</script>
<style>
table {
    border-spacing: 2px;
}

td {
    padding: 6px;
    vertical-align: top
}

.theme--light.v-table thead th {
    background-color: teal;
}
</style>